import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CartComponent } from './cart.component';
import { SharedModule } from '../shared/shared.module';
import { SharedCoreModule } from '../shared-core/shared-core.module';
import { SummaryComponent } from './summary/summary.component';
import { BundleListComponent } from './product-list/bundle-list/bundle-list.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductSavedForLaterListComponent } from './product-savedforlater-list/product-savedforlater-list.component';
import { PromotionComponent } from './promotion/promotion.component';
import { AccountModule } from '../account/account.module';
import { PromotionItemComponent } from './product-list/promotion-item/promotion-item.component';
import { BundleBuilderComponent } from './bundle-builder/bundle-builder.component';

@NgModule({
  imports: [CommonModule, SharedModule, SharedCoreModule, AccountModule],
  declarations: [
    ContactUsComponent,
    CartComponent,
    SummaryComponent,
    ProductListComponent,
    BundleListComponent,
    ProductSavedForLaterListComponent,
    PromotionComponent,
    PromotionItemComponent,
    BundleBuilderComponent
  ]
})
export class CartModule { }
